import { InjectionToken } from '@angular/core';
import { PdfGeneratorConfig } from '../type';

export const PDF_GENERATOR_CONFIG = new InjectionToken<PdfGeneratorConfig>('PDF_GENERATOR_CONFIG');
